'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (props) {
    return (0, _trueish2.default)(props, 'aria-hidden');
};

var _trueish = require('./trueish');

var _trueish2 = _interopRequireDefault(_trueish);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-a11y/lib/util/hidden-from-at.js
// module id = 1592
// module chunks = 95 96